import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Cookie-Notice-Modal-Parent" }
const _hoisted_2 = { class: "App-Cookie-Notice-P" }
const _hoisted_3 = { "m-tb-0": "" }
const _hoisted_4 = {
  style: {"font-size":"90%","line-height":"0.9rem"},
  "mute-secondary": "",
  "m-tb-0": ""
}
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      "custom-class": "App-Cookie-Notice-Modal",
      modelValue: _ctx.isOpen,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isOpen) = $event)),
      title: "We use cookies!",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "show-close": false,
      "lock-scroll": false,
      modal: true
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          (!_ctx.showOptions)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                icon: "el-icon-eye",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showOptions = true))
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode(" Show Options ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            icon: "el-icon-check",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.acceptTerms())),
            type: "primary"
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode(" Accept ", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_2, [
            _cache[5] || (_cache[5] = _createTextVNode(" We use cookies for the purposes of enabling site functionality and to monitor traffic to our website. By clicking ", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("b", null, "“Accept”", -1)),
            _cache[7] || (_cache[7] = _createTextVNode(" you consent to our use of cookies, as further described in our ", -1)),
            _createVNode(_component_el_button, {
              type: "text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visitCookiesPolicy()))
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" Cookies Policy ", -1)
              ]))]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_el_divider),
            _createVNode(_component_el_table, {
              data: _ctx.cookiesList,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "Cookie Name"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(scope.row.name), 1),
                    _createElementVNode("p", _hoisted_4, [
                      _createElementVNode("span", null, _toDisplayString(scope.row.description), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  align: "right",
                  prop: "name",
                  label: "Status",
                  width: "100"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_switch, {
                      disabled: !scope.row.canAlter,
                      modelValue: scope.row.value,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.value) = $event)
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ], 512), [
            [_vShow, _ctx.showOptions]
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}